"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var LocalNumberRender = /** @class */ (function (_super) {
    __extends(LocalNumberRender, _super);
    function LocalNumberRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalNumberRender.prototype.render = function () {
        var _a = this.props, value = _a.value, type = _a.type, currency = _a.currency, lng = _a.lng;
        var style = currency ? 'currency' : type;
        var maxDigits = type === 'percent' ? 17 : undefined;
        return new Intl.NumberFormat(lng, { style: style, currency: currency, maximumFractionDigits: maxDigits }).format(value);
    };
    return LocalNumberRender;
}(react_1.Component));
exports.default = LocalNumberRender;
